import { Box } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { brand } from '@/content/site'

interface LogoProps {
  height?: number
  /** Wrap in a home link (default true). */
  linked?: boolean
}

/**
 * True Forge emblem logo (transparent-BG badge). Never restyled or re-proportioned.
 */
export function Logo({ height = 56, linked = true }: LogoProps) {
  const img = (
    <Box
      component="img"
      src={brand.logoMark}
      alt={`${brand.name} — ${brand.tagline}`}
      width={height}
      height={height}
      sx={{ height, width: 'auto', display: 'block' }}
    />
  )
  if (!linked) return img
  return (
    <Box component={RouterLink} to="/" aria-label={`${brand.name} home`} sx={{ display: 'inline-flex' }}>
      {img}
    </Box>
  )
}
